import _ from 'lodash';
import { types } from '@/app/filters/filters';
import MemberSelection from '../components/member-selection/member-selection.vue';
import MemberAccounts from '../components/member-accounts/member-accounts.vue';
import PaymentInstructions from '../components/payment-instructions/payment-instructions.vue';
import PaymentInstructionsCustom from '../components/payment-instructions-custom/payment-instructions-custom.vue';
import Review from '../components/review/review.vue';

export default {
  name: 'workflow-container',
  components: {
    MemberSelection,
    MemberAccounts,
    PaymentInstructions,
    PaymentInstructionsCustom,
    Review,
  },
  data: () => ({
    devMode: process.env.NODE_ENV,
    currentStep: 0,
    currentChildStep: 0,
    disableStepper: false,
    stepperData: {
      title: 'Prospective Benefit Payment Instruction',
      style: 'blue',
      steps: [
        {
          step: 1,
          name: 'Member',
          children: [
            {
              component: 'member-selection',
            },
            {
              component: 'member-accounts',
            },
          ],
        },
        {
          step: 2,
          name: 'Payment Instructions',
          children: [
            {
              component: 'payment-instructions',
            },
            {
              component: 'payment-instructions-custom',
            },
          ],
        },
        {
          step: 3,
          name: 'Review',
          component: 'review',
        },
      ],
    },
  }),
  computed: {
    currentComponent() {
      const currentStep = this.stepperData.steps[this.currentStep];
      if (this.currentStepHasChild) {
        return currentStep.children[this.currentChildStep].component;
      }
      return currentStep.component;
    },
    currentStepHasChild() {
      const currentStep = this.stepperData.steps[this.currentStep];
      return Object.prototype.hasOwnProperty.call(currentStep, 'children');
    },
    pensionKitPaymentInstruction() {
      return this.$store.getters['toolkit/getItem'];
    },
    isComplete() {
      return this.pensionKitPaymentInstruction.status === 'COMPLETE';
    },
  },
  methods: {
    saveItem() {
      // eslint-disable-next-line no-unused-vars
      this.$store.dispatch('toolkit/saveItem').catch((err) => {});
    },
    handleStepChange(step) {
      this.$mixpanel.track('Toolkit Item', {
        status: types(this.pensionKitPaymentInstruction.status),
        type: this.pensionKitPaymentInstruction.type,
        context: 'Item Step',
        step: this.stepperData.steps[this.currentStep].name,
        action: 'Step',
        uuid: this.pensionKitPaymentInstruction.uuid,
      });
      if (typeof step === 'number') {
        this.currentStep = step;
      } else if (_.isArray(step)) {
        const [currentStep, currentChildStep] = step;

        this.currentStep = currentStep;
        // eslint-disable-next-line max-len
        this.currentChildStep = currentChildStep > this.stepperData.steps[currentStep].children.length - 1
          ? this.stepperData.steps[currentStep].children.length - 1
          : currentChildStep;
      }
      this.$nextTick(() => {
        this.$refs.container.scrollIntoView();
      });
    },
    handleBackStep() {
      this.$mixpanel.track('Toolkit Item', {
        status: types(this.pensionKitPaymentInstruction.status),
        type: this.pensionKitPaymentInstruction.type,
        context: 'Item Step',
        step: this.stepperData.steps[this.currentStep].name,
        action: 'Back',
        uuid: this.pensionKitPaymentInstruction.uuid,
      });
      if (this.currentStepHasChild) {
        if (this.currentChildStep > 0) {
          this.currentChildStep -= 1;
        } else {
          this.currentStep -= 1;
          if (this.currentStepHasChild) {
            const currentStep = this.stepperData.steps[this.currentStep];
            this.currentChildStep = currentStep.children.length - 1;
          }
        }
      } else {
        this.currentStep -= 1;
        this.currentChildStep = 0;
        if (this.currentStepHasChild) {
          const currentStep = this.stepperData.steps[this.currentStep];
          this.currentChildStep = currentStep.children.length - 1;
        }
      }
      this.saveItem();
      this.$nextTick(() => {
        this.$refs.container.scrollIntoView();
      });
    },
    handleNextStep() {
      this.$mixpanel.track('Toolkit Item', {
        status: types(this.pensionKitPaymentInstruction.status),
        type: this.pensionKitPaymentInstruction.type,
        context: 'Item Step',
        step: this.stepperData.steps[this.currentStep].name,
        action: 'Next',
        uuid: this.pensionKitPaymentInstruction.uuid,
      });
      const currentStep = this.stepperData.steps[this.currentStep];
      if (this.currentStepHasChild) {
        if (currentStep.children.length - 1 > this.currentChildStep) {
          this.currentChildStep += 1;
        } else {
          this.currentChildStep = 0;
          this.currentStep += 1;
        }
      } else {
        this.currentStep += 1;
      }
      this.saveItem();
      this.$nextTick(() => {
        this.$refs.container.scrollIntoView();
      });
    },
    handleFinalise() {
      this.currentStep = 2;
      this.saveItem();
      this.$nextTick(() => {
        this.$refs.container.scrollIntoView();
      });
    },
    handleDisableStepper(value) {
      this.disableStepper = value;
    },
  },
};
